/* Type theme */
/** ******************* */
var UitkDateNumberThemeMap = [
    ['default', 'uitk-date-number-default'],
    ['emphasis', 'uitk-date-number-emphasis'],
    ['muted', 'uitk-date-number-muted'],
    ['action', 'uitk-date-number-action'],
    ['today', 'uitk-date-number-today']
];
var UitkDateNumberThemes = new Map(UitkDateNumberThemeMap);
/* Type size */
/** ******************* */
var UitkTypeSizeMap = [
    [300, 'uitk-type-300'],
    [400, 'uitk-type-400']
];
var UitkTypeSizes = new Map(UitkTypeSizeMap);
/* Type weight */
/** ******************* */
var UitkTypeWeightMap = [
    ['regular', 'uitk-type-regular'],
    ['bold', 'uitk-type-bold']
];
var UitkTypeWeights = new Map(UitkTypeWeightMap);
/* Availability Background availability */
/** ******************* */
var UitkAvailabilityBackgroundAvailabilityMap = [
    ['available', 'uitk-background-available'],
    ['am-unavailable', 'uitk-background-am-unavailable'],
    ['pm-unavailable', 'uitk-background-pm-unavailable'],
    ['unavailable', 'uitk-background-unavailable']
];
var UitkAvailabilityBackgroundAvailabilities = new Map(UitkAvailabilityBackgroundAvailabilityMap);
var UitkEventBarThemeMap = [
    ['default', 'uitk-event-bar-default'],
    ['emphasis', 'uitk-event-bar-emphasis'],
    ['muted', 'uitk-event-bar-muted'],
    ['positive', 'uitk-event-bar-positive'],
    ['negative', 'uitk-event-bar-negative'],
    ['primary', 'uitk-event-bar-primary']
];
var UitkEventBarThemes = new Map(UitkEventBarThemeMap);
var UitkEventBarTypeMap = [
    ['solid', 'uitk-event-bar-type-solid'],
    ['bordered', 'uitk-event-bar-type-bordered'],
    ['bordered-muted-fill', 'uitk-event-bar-type-bordered-muted-fill'],
    ['dashed-border', 'uitk-event-bar-type-dashed-border'],
    ['dashed-border-muted-fill', 'uitk-event-bar-type-dashed-border-muted-fill'],
    ['line-fill-narrow', 'uitk-event-bar-type-line-fill-narrow'],
    ['line-fill-wide', 'uitk-event-bar-type-line-fill-wide']
];
var UitkEventBarTypes = new Map(UitkEventBarTypeMap);

export { UitkAvailabilityBackgroundAvailabilities, UitkDateNumberThemes, UitkEventBarThemes, UitkEventBarTypes, UitkTypeSizes, UitkTypeWeights };
